export var Crm;
(function (Crm) {
    Crm["BITRIX"] = "BITRIX";
    Crm["SYNERGY"] = "SYNERGY";
})(Crm || (Crm = {}));
